'use strict';

angular.module('transport.changeRequests.changeRequestsApprovedOrRejected', [
    'transport.changeRequests.transportReviewChangeRequest',
    'shared.components.sbColumnHeader',
    'shared.components.sbIcon',
    'shared.components.sbTextarea',
    'shared.components.sbAvatar',
    'shared.services.blobStoragePhotosService'
])
    .component('changeRequestsApprovedOrRejected', {
        templateUrl: '/Scripts/app/transport/changeRequests/transport-change-requests-approved-rejected.template.html',
        bindings: {
            transportChangeRequests : '<',
            onChangeRequestsUpdated: '<',            
            onChangeRequestOpen: '&',
            onChangeRequestViewOpen: '&'
        },
        controller: [
            '$uibModal',
            'blobStoragePhotosService',
            function changeRequestsApprovedOrRejected($uibModal, blobStoragePhotosService)
            {
                this.groupedTransportChangeRequests = [];

                this.$onChanges = function(changes) {
                    if (changes.transportChangeRequests) {                        
                        var currentRequests = changes.transportChangeRequests.currentValue;
                        if (currentRequests && currentRequests.length > 0) {
                            let grouped = {};
                            angular.forEach(currentRequests, function(request) {
                                const refNum = request.referenceNumber;

                                if (!grouped[refNum]) {
                                    grouped[refNum] = {
                                        ...request,
                                        referenceNumber: refNum,
                                        calendarEventStartDates: [],
                                        transportOptionChangeFrom: request.transportOptionChangeFrom,
                                        transportOptionChangeTo: request.transportOptionChangeTo
                                    };
                                }

                                grouped[refNum].calendarEventStartDates?.push(request.calendarEventStartDateTime);

                                if (grouped[refNum].transportOptionChangeFrom != 'Multiple' 
                                    && (grouped[refNum].transportOptionChangeFrom?.transportChangeRequestOption?.name != request.transportOptionChangeFrom?.transportChangeRequestOption?.name
                                        || (grouped[refNum].transportOptionChangeFrom?.transportChangeRequestOption?.timetableRoute?.timetableRouteStop && request.transportOptionChangeFrom?.transportChangeRequestOption?.timetableRoute?.timetableRouteStop
                                            && grouped[refNum].transportOptionChangeFrom?.transportChangeRequestOption?.timetableRoute?.timetableRouteStop?.routeStopId != request.transportOptionChangeFrom?.transportChangeRequestOption?.timetableRoute?.timetableRouteStop?.routeStopId)
                                )) {
                                    grouped[refNum].transportOptionChangeFrom = 'Multiple';
                                }

                                if (grouped[refNum].transportOptionChangeTo != 'Multiple' 
                                    && (grouped[refNum].transportOptionChangeTo?.transportChangeRequestOption?.name != request.transportOptionChangeTo?.transportChangeRequestOption?.name
                                        || (grouped[refNum].transportOptionChangeTo?.transportChangeRequestOption?.timetableRoute?.timetableRouteStop && request.transportOptionChangeTo?.transportChangeRequestOption?.timetableRoute?.timetableRouteStop
                                            && grouped[refNum].transportOptionChangeTo?.transportChangeRequestOption?.timetableRoute?.timetableRouteStop?.routeStopId != request.transportOptionChangeTo?.transportChangeRequestOption?.timetableRoute?.timetableRouteStop?.routeStopId)
                                )) {
                                    grouped[refNum].transportOptionChangeTo = 'Multiple';
                                }
                            });

                            this.groupedTransportChangeRequests = Object.keys(grouped).map(function(key) {
                                return grouped[key];
                            });

                            if (this.groupedTransportChangeRequests && this.groupedTransportChangeRequests.length > 0) {
                                blobStoragePhotosService.addStudentPhotoUrlsToArray(this.groupedTransportChangeRequests, 'pupilPersonId').then(function (array) {
                                    this.groupedTransportChangeRequests = array;
                                }.bind(this));
                            }
                        }
                    }
                }.bind(this);

                this.viewReviewChangeRequest = function (changeRequest)
                {
                    this.onChangeRequestViewOpen({ changeRequest: changeRequest });
                }.bind(this);

                this.viewAddChangeRequest = function () {
                    this.isDisabled = true;
                    let vm = this;
                    var modalInstance = $uibModal.open({
                        animation: true,
                        backdrop: 'static',
                        component: 'studentPickerWithDiaryEvents',
                        size: 'lg',
                        windowClass: 'modal-scroll',
                        resolve: {
                            onChangeRequestModalOpen: function() {
                                return vm.onChangeRequestOpen.bind(vm);
                            },
                            onChangeRequestViewModalOpen: function() {
                                return vm.onChangeRequestViewOpen.bind(vm);
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        this.isDisabled = false;

                        this.onChangeRequestsUpdated();

                    }.bind(this), function () { });

                }.bind(this);
            }
        ]
});
